import { Box, Grid, SxProps, Typography } from "@mui/material";
import { Control, FieldErrors } from "react-hook-form";
import NumberInput from "./NumberInput";
import { Theme } from "@emotion/react";

export function RopHighlightSingleValueInput(props: {
  control: Control<any>;
  errors: FieldErrors<any>;
  fieldName: string;
  label: string;
  sx: SxProps<Theme>;
}) {
  const { control, errors, fieldName, label, sx } = props;
  return (
    <Grid display={"flex"} item xl={2} xs={12} sm={4} md={3}>
      <Box width={"100%"}>
        <Typography
          sx={{
            fontWeight: "bold",
            marginBottom: "5px",
          }}
        >
          {label}
        </Typography>
        <NumberInput
          control={control}
          errors={errors}
          fieldName={fieldName}
          label=""
          sx={sx}
        />
      </Box>
    </Grid>
  );
}
